import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AccessGuard {
  constructor(protected auth: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.auth.ready$.pipe(filter(e => !!e)).pipe(map(
      () => {
        if (!this.auth.keycloak.token) {
          this.auth.keycloak.login();
          return false;
        }
        return true;
      }
    ))
  }
}
